module.exports = __webpack_public_path__ + "media/entities/1127-a628254e.png";